import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {useTranslation} from "react-i18next";

export const ConfirmDelete = ({show, onConfirm, onCancel}) => {
    const {t} = useTranslation();

    return (
        <SweetAlert
            show={show}
            warning
            title={t("MODAL.CONFIRM_DELETE.TITLE")}
            showCancel
            confirmBtnText={t("MODAL.CONFIRM_DELETE.CONFIRM_BTN")}
            confirmBtnBsStyle="danger"
            focusConfirmBtn
            onConfirm={onConfirm}
            onCancel={onCancel}
        >
            {t("MODAL.CONFIRM_DELETE.DESCRIPTION")}
        </SweetAlert>
    );
};

export const SuccessDelete = ({show, onConfirm}) => {
    const {t} = useTranslation();

    return (
        <SweetAlert
            show={show}
            success
            title={t("MODAL.CONFIRM_DELETE.VIDEO.SUCCESS")}
            confirmBtnText={t("GENERAL.OK")}
            confirmBtnBsStyle="primary"
            onConfirm={onConfirm}
        />
    );
};

export const FailedDelete = ({show, onConfirm}) => {
    const {t} = useTranslation();

    return (
        <SweetAlert
            show={show}
            error
            title={t("MODAL.CONFIRM_DELETE.VIDEO.FAIL")}
            confirmBtnText={t("GENERAL.OK")}
            confirmBtnBsStyle="primary"
            onConfirm={onConfirm}
        />
    );
};
